import styled, { keyframes } from "styled-components";

// --- ANIMAÇÕES ---
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;
const fadeIn = keyframes`
  from { opacity: 0; } to { opacity: 1; }
`;
const slideIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

// --- CONTAINER PRINCIPAL ---
export const NewsContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
  box-sizing: border-box;
  padding: 60px 5%;
`;

// --- CABEÇALHO DA PÁGINA ---
export const PageHeader = styled.header`
  text-align: center;
  margin-bottom: 50px;
  animation: ${fadeInUp} 0.5s ease-out;
`;
export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #e6aa3a;
  margin: 0;
  font-weight: 800;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;
export const PageSubtitle = styled.p`
  font-size: 1.1rem;
  color: #a0a0a0;
  margin-top: 10px;
`;

// --- GRID E CARDS ---
export const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 30px;
`;
export const NewsCard = styled.article`
  background: rgba(26, 26, 26, 0.8);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  animation: ${fadeInUp} 0.5s ease-out backwards;
  cursor: pointer;
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 25px rgba(230, 170, 58, 0.2);
    border-color: #e6aa3a;
  }
`;
export const CardContent = styled.div`
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
export const CardTitle = styled.h3`
  font-size: 1.25rem;
  color: #eaeaea;
  font-weight: 600;
  margin-top: 10px;
  line-height: 1.4;
  flex-grow: 1; /* Garante que o conteúdo cresça e empurre a data para baixo */
`;

// --- ELEMENTOS DE MÍDIA (IMAGEM E VÍDEO) ---
const mediaStyles = `
    width: 100%; object-fit: cover; background-color: #111;
`;
export const CardImage = styled.img`
  ${mediaStyles}
  height: ${(props) => (props.isModal ? "400px" : "220px")};
`;
export const CardVideo = styled.video`
  ${mediaStyles}
  height: ${(props) => (props.isModal ? "400px" : "220px")};
`;
export const MediaPlaceholder = styled.div`
  ${mediaStyles}
  height: 220px;
  background-color: #222;
`;

// --- ELEMENTOS COMPARTILHADOS ---
export const NewsMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #a0a0a0;
`;
export const NoNewsMessage = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #a0a0a0;
  padding: 50px;
  background: rgba(20, 20, 20, 0.8);
  border-radius: 16px;
`;

// --- ESTILOS DO MODAL ---
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  animation: ${fadeIn} 0.3s ease;
`;
export const ModalContent = styled.div`
  background: #1c1c1c;
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: ${slideIn} 0.4s ease-out;
`;
export const ModalCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  &:hover {
    background: #e6aa3a;
    color: #111;
    transform: rotate(90deg);
  }
`;
export const ModalTextContent = styled.div`
  padding: 30px;
  overflow-y: auto;
`;
export const ModalTitle = styled.h2`
  font-size: 2rem;
  color: #ffffff;
  margin: 15px 0;
  font-weight: 700;
  line-height: 1.2;
`;
export const ModalText = styled.p`
  font-size: 1rem;
  color: #c0c0c0;
  line-height: 1.7;
`;
export const ModalFooter = styled.footer`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;
export const ReadMoreLink = styled.a`
  display: inline-block;
  padding: 12px 24px;
  background-color: #e6aa3a;
  color: #111;
  text-decoration: none;
  font-weight: bold;
  border-radius: 8px;
  transition: all 0.3s ease;
  &:hover {
    background-color: #ffc300;
    transform: translateY(-3px);
  }
`;
